import { FC } from 'react';

interface ISvgProps {}

export const ExcelIcon: FC<ISvgProps> = () => {
	return (
		<svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12 0.5H4C3.46957 0.5 2.96086 0.710714 2.58579 1.08579C2.21071 1.46086 2 1.96957 2 2.5V17.5C2 18.0304 2.21071 18.5391 2.58579 18.9142C2.96086 19.2893 3.46957 19.5 4 19.5H16C16.5304 19.5 17.0391 19.2893 17.4142 18.9142C17.7893 18.5391 18 18.0304 18 17.5V6.5L12 0.5Z"
				fill="#22A565"
			/>
			<path
				d="M11.9961 5.49609V0.5L18 6.49609H12.9961C12.4438 6.49609 11.9961 6.04838 11.9961 5.49609Z"
				fill="#168D53"
			/>
			<path
				d="M8.33449 14.9365L7.20949 13.2515L8.26449 11.6365H7.33449L6.76449 12.6865L6.19449 11.6365H5.17949L6.23449 13.2765L5.11449 14.9365H6.08949L6.68949 13.8515L7.30949 14.9365H8.33449ZM9.76992 14.2715V11.6365H8.90992V14.9365H11.4249V14.2715H9.76992ZM13.3777 11.5865C12.4727 11.5865 11.9577 12.0415 11.9577 12.6615C11.9577 13.3065 12.4627 13.5365 13.2427 13.6915C13.6927 13.7765 13.8827 13.8615 13.8827 14.0165C13.8827 14.2065 13.7027 14.3165 13.3327 14.3165C12.8927 14.3165 12.5727 14.2015 12.3027 13.8265L11.8627 14.4265C12.1877 14.7865 12.5977 14.9865 13.3777 14.9865C14.1727 14.9865 14.7727 14.6165 14.7727 13.9715C14.7727 13.3915 14.4177 13.0965 13.5027 12.9315C13.0327 12.8465 12.8527 12.7565 12.8527 12.5865C12.8527 12.3965 13.0377 12.2565 13.3927 12.2565C13.8127 12.2565 14.0927 12.4115 14.3127 12.7415L14.7977 12.1815C14.4177 11.7565 13.9977 11.5865 13.3777 11.5865Z"
				fill="white"
			/>
		</svg>
	);
};
